// Routes de l'urbanisme (lot L5-C2, M18), raccordées dans Application.tsx par une seule ligne.
import type { RouteObject } from 'react-router';
import { PageConfiguration } from './PageConfiguration';
import { PageDemande } from './PageDemande';
import { PageDemandes } from './PageDemandes';

export const routesUrbanisme: RouteObject[] = [
  { path: '/urbanisme', element: <PageDemandes /> },
  { path: '/urbanisme/configuration', element: <PageConfiguration /> },
  { path: '/urbanisme/demandes/:id', element: <PageDemande /> },
];
